import { Animated, Easing, StyleSheet } from 'react-native';
import { cardTitleConfig, tokens } from '../../constants';
import { checkIsPlatform } from '../../utils';
import merge from 'lodash/merge';
export var getInterpolatedRotationValue = (animationRotation, props) => {
  var value = (props === null || props === void 0 ? void 0 : props.actionRotationAngle) || '0deg';
  return animationRotation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', value]
  });
};
export var startRotationAnimation = (animationRotation, isExpanded) => {
  Animated.timing(animationRotation, {
    toValue: isExpanded ? 1 : 0,
    duration: 200,
    easing: Easing.ease,
    useNativeDriver: !checkIsPlatform('web')
  }).start();
};
export var getCardTitleStyles = () => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    iconImgContainer: {
      flexShrink: 0,
      alignItems: 'center',
      flexDirection: 'row'
    },
    iconImg: {
      marginRight: 4
    },
    content: {
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1
    },
    title: {
      marginRight: tokens.spacing.SPACING_4
    },
    actionsContainer: {
      flexShrink: 0
    },
    infoIcon: {
      marginLeft: tokens.spacing.SPACING_4
    }
  });
};
export var getCardTitleProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(cardTitleConfig === null || cardTitleConfig === void 0 ? void 0 : cardTitleConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.cardTitle) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};